/**
 *
 */
(function () {
  'use strict';
  angular.module('cbl.finanza.mf.directives').directive('finCalendar', [
    'FIN_CONSTANTS',
    function (CONSTANTS) {
      return {
        restrict: 'E',
        require: 'ngModel',
        scope: {
          value: '=ngModel',
          placeholder: '=',
          ngRequired: '=',
          ngDisabled: '=',
          minDate: '=?',
          maxDate: '=?',
          ngClass: '=',
          cblChange: '=',
          name: '='
        },
        templateUrl:
          CONSTANTS.BASE_ROOT + 'widgets/finCalendar/finCalendar.html',
        controller: [
          '$scope',
          function ($scope) {
            if ($scope.minDate == undefined) {
              $scope.minDate = null;
            }
            if ($scope.maxDate == undefined) {
              $scope.maxDate = null;
            }
          }
        ],
        link: link
      };

      function link(scope, element, attr, ctrls) {}
    }
  ]);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/finCalendar/finCalendarDrct.js
 ** module id = 4
 ** module chunks = 0 1 2
 **/